module.exports = __webpack_public_path__ + "static/img/pickup-singlecab-orange.b8f3666.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-singlecab-orange.svg
// module id = A8oW
// module chunks = 82